import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { inject, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { NGXLogger } from 'ngx-logger';
import { MainComponent } from '../core/components/main/main.component';
import { mainConfig } from './configurations';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

bootstrapApplication(MainComponent, {
  ...mainConfig,
  providers: [provideZonelessChangeDetection(), ...mainConfig.providers],
}).catch((error) => {
  const logger = inject(NGXLogger);
  logger.error('Error during application bootstrap:', error);
});
